import { z } from 'zod';

// Common schema for name-only entities (activity types, task types, event types, payment methods, matter/contract practice areas)
export const nameOnlySchema = z.object({
  name: z.string().min(1, 'Name is required'),
});

export type NameOnlyFormValues = z.infer<typeof nameOnlySchema>;

// Contract Period schema (has additional interval field)
export const contractPeriodSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  interval: z.number().min(1, 'Interval must be at least 1'),
});

export type ContractPeriodFormValues = z.infer<typeof contractPeriodSchema>;
